<template>
    <div class='form-group'>
        <label v-if='label'>
            {{ label }}
            <span v-if='required' class='text-danger'>*</span>
            <font-awesome-icon icon="info-circle" class="ms-1 text-info" v-if="info" v-tooltip="info" /><br>
            <small v-if='subInfo' class='text-info d-block' style="margin-top: -5px">{{ subInfo }}</small>
        </label>
        <input :type='type'
               :class='["form-control", {"is-invalid" : errors && errors.length}]'
               :placeholder='placeholder'
               :value='modelValue'
               :required='required'
               v-money3='config'
               @input='updateValue'
               :disabled="disabled"
        >

        <div v-if='errors && errors.length' class='invalid-feedback' v-for='(error, index) in errors'
             :key='`invalid-feedback-${index}`'> {{ error }}
        </div>
    </div>
</template>

<script setup>
    import { ref } from 'vue';
    import { format, unformat } from 'v-money3';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    const emit = defineEmits(['update:modelValue']);

    const config = ref({
        prefix: 'R$ ',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 2,
        disableNegative: false,
        disabled: false,
        min: null,
        max: null,
        allowBlank: false,
        minimumNumberOfCharacters: 0
    });

    const props = defineProps({
        label: { type: String, default: null },
        placeholder: { type: String, default: '' },
        required: { type: Boolean, default: false },
        errors: { default: null },
        modelValue: { type: [String, Number] },
        type: { type: String, default: 'text' },
        disabled: { type: Boolean, default: false },
        info: { type: String, default: '' },
        subInfo: { type: String, default: '' }
    });

    const updateValue = (event) => {
        const value = unformat(event.target.value);
        emit('update:modelValue', value);
    };
</script>
